import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NewOwnerComponent from "../component/new-request-component"
import RequestPage from "../page/request.page"
export const RequestRoute: RouteObject = {
  path: "/request",
  element: (
    <AuthGuard role={["super_admin", "admin"]} permission={["manage-requests", "view-requests"]}>
      <RequestPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewOwnerComponent editMode="detail" />,
    },
    { path: ":id", element: <NewOwnerComponent editMode="new" /> },
  ],
}
